import React from 'react';

const GeneralEditContext = React.createContext({
    anyFieldChanged: undefined,
    countryCode: undefined,
    countryCodeError: undefined,
    enableUserProfileStandardization: undefined,
    firstName: undefined,
    language: undefined,
    lastName: undefined,
    legalNameVerified: undefined,
    middleName: undefined,
    onCancelClick: undefined,
    onCountryCodeChange: undefined,
    onFirstNameChange: undefined,
    onLastNameChange: undefined,
    onLegalNameVerifiedChange: undefined,
    onMiddleNameChange: undefined,
    onPhoneChange: undefined,
    onPrefixChange: undefined,
    onSaveClick: undefined,
    onSuffixChange: undefined,
    phone: undefined,
    phoneDisabled: undefined,
    phoneError: undefined,
    prefix: undefined,
    saveButtonDisabled: undefined,
    suffix: undefined,
});

GeneralEditContext.displayName = 'GeneralEditContext';

export default GeneralEditContext;
